import React from 'react';
import Rate from 'antd/lib/rate';
import PropTypes from 'prop-types';
import accounting from 'accounting';
import EmptyPicIcon from '../FreelancerChooser/empty-pic.svg';
import PinIcon from '../FreelancerChooser/pin.svg';
import { Button } from '../Button';
import './FreelancerProfileCard.css';

export const FreelancerProfileCard = ({
  bid = {},
  freelancer,
  handleBookNow,
  bidRequested,
  bidAction,
  bidding,
}) => (
  <div className="freelancer-profile-popup__freelancers-card">
    {instantBookingLabel(freelancer, bidding)}
    <img
      className="freelancer-profile-popup__freelancers-picture"
      alt="freelancer"
      src={freelancer.avatar_url ? freelancer.avatar_url : EmptyPicIcon}
    />
    <div className="freelancer-profile-popup__freelancers-name">
      {freelancer.name}
    </div>
    <div className="freelancer-profile-popup__freelancers-state">
      {freelancer.state && (
        <span className="freelancer-profile-popup__freelancers-span">
          <img alt="map pin" src={PinIcon} />
          <span> {freelancer.state}</span>
        </span>
      )}
    </div>
    <div className="freelancer-profile-popup__freelancers-rate">
      <Rate allowHalf disabled defaultValue={5} />
    </div>
    <div className="freelancer-profile-popup__freelancers-response-rate">
      60% Response Rate | 6 Projects
    </div>

    {bidding && (
      <div className="freelancer-profile-popup__freelancers-bio">
        {freelancer.bio}
      </div>
    )}

    {bidding && (
      <div className="freelancer-profile-popup__freelancers-actions">
        {freelancer.instant_book && (
          <Button
            flat
            rounded
            className="freelancer-profile-popup__freelancers-actions--medium"
            textClassName="freelancer-profile-popup__freelancers-actions--text-small"
            title="Book now"
            onClick={() => handleBookNow(freelancer)}
          />
        )}

        <Button
          flat
          rounded
          bordered={!bidRequested}
          toggle={bidRequested}
          className={`freelancer-profile-popup__freelancers-actions--${
            freelancer.instant_book ? 'medium' : 'large'
          }`}
          textClassName={
            bidRequested
              ? 'freelancer-profile-popup__freelancers-actions--disabled'
              : 'freelancer-profile-popup__freelancers-actions--text-small'
          }
          title={bidRequested ? 'Requested' : 'Request a bid'}
          onClick={bidAction}
        />
      </div>
    )}

    {!bidding && (
      <div className="freelancer-profile-popup__freelancers-bid">
        <div className="freelancer-profile-popup__freelancers-bid-value">
          {bid.freelancer_price && (
            <span className="freelancer-profile-popup__freelancers-bid-label">
              ${accounting.format(bid.freelancer_price)}
            </span>
          )}
        </div>
        <div className="freelancer-profile-popup__freelancers-actions">
          <Button
            rounded
            className="freelancer-profile-popup__freelancers-actions"
            title={bid.freelancer_price ? 'Accept Bid' : 'Waiting for Bid'}
            disabled={!bid.freelancer_price}
            onClick={() => bidAction(bid.id)}
          />
        </div>
      </div>
    )}
  </div>
);

const instantBookingLabel = (freelancer, bidding) =>
  freelancer.instant_book && bidding ? (
    <div>
      <div className="freelancer-profile-popup__freelancers-instant-book-tag">
        Instant book
      </div>
      <div className="freelancer-profile-popup__freelancers-instant-book-price">
        $2,930
      </div>
    </div>
  ) : null;

FreelancerProfileCard.propTypes = {
  bid: PropTypes.shape({
    freelancer_price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  }),
  freelancer: PropTypes.shape({
    name: PropTypes.string,
    bio: PropTypes.string,
    state: PropTypes.string,
    avatar_url: PropTypes.string,
    instant_book: PropTypes.bool,
  }),
  handleBookNow: PropTypes.func,
  bidRequested: PropTypes.bool,
  bidding: PropTypes.bool,
  bidAction: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/FreelancerProfileCard/FreelancerProfileCard.js